import MainNavigation from "./MainNavigation";
import classes from "./PageLayout.module.scss";
import { EqFooter, EqFeedBackButton } from "@equitable/equx";
import { useTranslation } from "react-i18next";
import { appConfig } from "@/common/config/appConfig";
import { Language } from "@/common/utils/constants";
import { useProductInfo } from "@/common/context/productInfoProvider";
import { getExternalServicesIds } from "@/common/utils/helpers";
import { useApplicationInfo } from "@/common/context/ApplicationInfoProvider";
import { useAdvisorInfo } from "@/common/context/advisorCodeInfoProvider";
import { HeapAnalytics, GoogleTagManager } from "@/components/shared";

function PageLayout(props: any) {
  const { t, i18n } = useTranslation();
  const productName = useProductInfo();
  const { alidaId, gtmId, heapId } = getExternalServicesIds(productName?.data?.code);
  const applicationInfo = useApplicationInfo();
  const advisorInfo = useAdvisorInfo();
  const {selectedAdvisorCode} = advisorInfo;
  const { userInfo } = applicationInfo;
  const alidaFeedback = () => {
   (window as any)?.Touchpoint?.initialize({
      // Please check documentation for other Touchpoint settings that can be configured
      settings: {
        containerStyle: {
          borderRadius: "8px",
          boxShadow: "0px 3px 5px 0px rgba(0,0,0,0.2), 0px 1px 18px 0px rgba(0,0,0,0.12), 0px 6px 10px 0px rgba(0,0,0,0.14)",
        },
      },
      visitor: {
        // Pass data points from your site/application to identify the current respondent
        user_name: userInfo?.UserName,
        advisor_code: selectedAdvisorCode ?? undefined,
        product_type: productName?.data?.name
      },
      user_attributes: {
        // Define attribute data types to be used for targeting.
        // Dates must be in ISO 8601 format
        user_name: 'string',
        advisor_code: 'string',
        product_type: 'string'
      },
      publisher: {
        // Please do not make edits below
        app_id: alidaId,
        pod: "na1",
      },
    });
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      <GoogleTagManager gtmId={gtmId} />
      <HeapAnalytics heapId={heapId} />

      <div lang={i18n.language}>
        <noscript>
          <iframe src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`} height="0" width="0" style={{ display: "none", visibility: "hidden" }}></iframe>
        </noscript>

        <EqFeedBackButton label={t("provideFeedback")} onClick={alidaFeedback} position="fixed" aria-label={t("provideFeedback")} />
        <MainNavigation />
        <main className={classes.main}>{props.children}</main>
        <footer className={classes.footer}>
          <EqFooter
            copyrightText={t("copyright",{currentYear: currentYear})}
            footerLink={[
              {
                href: i18n.language === Language.fr ? appConfig.LEGAL_URL_FR : appConfig.LEGAL_URL,
                label: t("legal"),
                target: "_blank",
              },
              {
                href: i18n.language === Language.fr ? appConfig.PRIVACY_URL_FR :appConfig.PRIVACY_URL,
                label: t("privacy"),
                target: "_blank",
              },
              {
                href: i18n.language === Language.fr ? appConfig.SECURITY_URL_FR : appConfig.SECURITY_URL,
                label: t("security"),
                target: "_blank",
              },
            ]}
            trademarkText={t("tradeMark")}
          />
        </footer>
      </div>
    </>
  );
}

export default PageLayout;
